import BannerComp from "../../components/BannerComp";
import FeatureCard from "../../components/FeatureCard";
import FeatureFlow from "../../components/FeatureFlow";
import FeatureImageContent from "../../components/FeatureImageContent";
import IconBenefitGrid from "../../components/IconBenefitGrid";
import Seo from "../../components/Seo";
import {
  featureCardData,
  featureFlowData,
  iconBenefitData,
} from "../../data/neurofeed";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";

const seo = {
  title: "Neurofeedback & Beyond | MIT4Doctors",
  description:
    "MITSI provides Neurofeedback Services. We use a proven method to find and manage unusual brain waves.",
  schema: [
    createWebPageSchema({
      path: "/services/neurofeedback",
      title: "Neurofeedback & Beyond",
      description:
        "MITSI provides Neurofeedback Services. We use a proven method to find and manage unusual brain waves.",
    }),
    createBreadcrumbSchema("/services/neurofeedback", "Neurofeedback & Beyond"),
  ],
};

export default function NeurofeedbackBeyond() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/neurofeedback"
        schema={seo.schema}
      />
      <BannerComp
        heading="Neurofeedback & Beyond"
        paragraph="MITSI provides Neurofeedback Services. We use a proven method to find and manage unusual brain waves."
        centered
        BannerBgImg="/img/banners/neurofeeback_hero.webp"
      />
      <Section1 />
      <IconBenefitGrid
        title="Who Can Benefit from Neurofeedback?"
        description="Neurofeedback therapy is for adults, teens, and children (6+). It may help those experiencing:"
        highlightWords="Neurofeedback?"
        items={iconBenefitData}
      />

      <FeatureCard
        sectionTitle="What to Expect with Our Program"
        sectionDescription="Our Neurofeedback program uses brain mapping and training. It
            improves focus, emotional control, and reduces nervousness."
        highlightText="Our Program"
        features={featureCardData}
      />

      <FeatureFlow
        heading="Neurofeedback Benefits"
        highlights={["Benefits"]}
        paragraph="A drug-free solution to improve brain efficiency and mood. It works for all ages and lasts."
        steps={featureFlowData}
      />

      <FeatureImageContent
        heading="Revamping Your Practice with MITSI"
        description="Improve patient care and increase revenue. Provide innovative, evidence-based solutions for mental and neurological health at no upfront cost."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Revamping Your Practice with MITSI"
      />
      <Section2 />
    </>
  );
}
